(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-stats-stats-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-f2-stats-stats-domain'.");
    }
    root['boislocal-platform-platform-f2-stats-stats-domain'] = factory(typeof this['boislocal-platform-platform-f2-stats-stats-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-f2-stats-stats-domain'], this['kotlin-kotlin-stdlib']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  //endregion
  //region block: pre-declaration
  setMetadataFor(OuvrageIndicatorsDTO, 'OuvrageIndicatorsDTO', interfaceMeta);
  setMetadataFor(RealizationIndicatorsDTO, 'RealizationIndicatorsDTO', interfaceMeta);
  setMetadataFor(StatsDTO, 'StatsDTO', interfaceMeta);
  setMetadataFor(StatsGetQueryDTO, 'StatsGetQueryDTO', interfaceMeta);
  setMetadataFor(StatsGetResponseDTO, 'StatsGetResponseDTO', interfaceMeta);
  //endregion
  function OuvrageIndicatorsDTO() {
  }
  function RealizationIndicatorsDTO() {
  }
  function StatsDTO() {
  }
  function StatsGetQueryDTO() {
  }
  function StatsGetResponseDTO() {
  }
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$stats = $org$boislocal$platform$s2.stats || ($org$boislocal$platform$s2.stats = {});
    var $org$boislocal$platform$s2$stats$domain = $org$boislocal$platform$s2$stats.domain || ($org$boislocal$platform$s2$stats.domain = {});
    var $org$boislocal$platform$s2$stats$domain$model = $org$boislocal$platform$s2$stats$domain.model || ($org$boislocal$platform$s2$stats$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$stats = $org$boislocal$platform$s2.stats || ($org$boislocal$platform$s2.stats = {});
    var $org$boislocal$platform$s2$stats$domain = $org$boislocal$platform$s2$stats.domain || ($org$boislocal$platform$s2$stats.domain = {});
    var $org$boislocal$platform$s2$stats$domain$model = $org$boislocal$platform$s2$stats$domain.model || ($org$boislocal$platform$s2$stats$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$stats = $org$boislocal$platform$s2.stats || ($org$boislocal$platform$s2.stats = {});
    var $org$boislocal$platform$s2$stats$domain = $org$boislocal$platform$s2$stats.domain || ($org$boislocal$platform$s2$stats.domain = {});
    var $org$boislocal$platform$s2$stats$domain$model = $org$boislocal$platform$s2$stats$domain.model || ($org$boislocal$platform$s2$stats$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$stats = $org$boislocal$platform$s2.stats || ($org$boislocal$platform$s2.stats = {});
    var $org$boislocal$platform$s2$stats$domain = $org$boislocal$platform$s2$stats.domain || ($org$boislocal$platform$s2$stats.domain = {});
    var $org$boislocal$platform$s2$stats$domain$query = $org$boislocal$platform$s2$stats$domain.query || ($org$boislocal$platform$s2$stats$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-f2-stats-stats-domain.js.map
